module.exports = __webpack_public_path__ + "img/logo.4710e49c.svg";